import { FC, MouseEvent } from "react";

import { Stack } from "@mui/material";
import { TicketingFormCategory } from "@simplyk/common";

import { getStepQuestionsV4Wording } from "../helpers/getStepQuestionsV4Wording";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardChipFilterItem } from "@/dashboard-design-system/DashboardChipFilter";

export type QuestionScopeTab = "buyer" | "participant";

interface ScopeTogglePillsProps {
  value: QuestionScopeTab;
  onChange: (value: QuestionScopeTab) => void;
  disabled?: boolean;
  formCategory?: TicketingFormCategory;
}

export const ScopeTogglePills: FC<ScopeTogglePillsProps> = ({ value, onChange, disabled, formCategory }) => {
  const { t } = useTranslate();
  const wording = getStepQuestionsV4Wording(t, formCategory);

  const selectScope = (scope: QuestionScopeTab) => (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    onChange(scope);
  };

  const participantPill = (
    <DashboardChipFilterItem
      key="participant"
      value="participant"
      label={wording.attendeeToggleLabel}
      selected={value === "participant"}
      onClick={selectScope("participant")}
      disabled={disabled}
      data-test="v4-scope-pill-guest"
    />
  );

  const buyerPill = (
    <DashboardChipFilterItem
      key="buyer"
      value="buyer"
      label={wording.buyerToggleLabel}
      selected={value === "buyer"}
      onClick={selectScope("buyer")}
      disabled={disabled}
      data-test="v4-scope-pill-buyer"
    />
  );

  return (
    <Stack direction="row" spacing={1}>
      {wording.isBuyerSectionFirst ? [buyerPill, participantPill] : [participantPill, buyerPill]}
    </Stack>
  );
};
